module.exports = "/assets/data/452ee8288675c395486f02fcdf4856bc-SS16.data.json";